// extracted by mini-css-extract-plugin
export default {"info":"profile-change-pwd_info__r61Ku","form":"profile-change-pwd_form__9Igpb","datos":"profile-change-pwd_datos__XH07B","buttonContent":"profile-change-pwd_buttonContent__2FAQK"};